import { Link } from 'react-router-dom';
import { games, type Game } from '@/mocks/games';

function GameCard({ game }: { game: Game }) {
  return (
    <Link
      to={`/article/article-001`}
      className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer no-underline"
    >
      <div className="relative w-full h-44 overflow-hidden">
        <img
          src={game.imageUrl}
          alt={game.title}
          title={game.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {game.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
            新游
          </span>
        )}
        <div className="absolute top-2 right-2 px-2 py-0.5 bg-black/60 text-white text-xs font-medium rounded-md flex items-center gap-1">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          {game.rating}
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-base font-heading text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors duration-200">
          {game.title}
        </h3>
        <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {game.description}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5 flex-wrap">
            {game.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md">
                {tag}
              </span>
            ))}
          </div>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-user-line"></i>
            {game.players}
          </span>
        </div>
      </div>
    </Link>
  );
}

export default function FeaturedGames() {
  const featuredGames = games.filter((g) => g.featured).slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
            精选热门游戏
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            严选平台最受欢迎的游戏，每一款都经过精心挑选，为你带来极致的游戏体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {featuredGames.map((game) => (
            <GameCard key={game.id} game={game} />
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/category/role-playing"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部游戏
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}